import React from 'react';
import './templateSection.scss'
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import {useStaticQuery, graphql} from 'gatsby'
import {getRedirectionLink, pushToDataLayer} from "../../../utils/redirectToTryForFree";
import ButtonLink from "../../common/buttonLink/buttonLink";

function TemplateSection() {

  const query = useStaticQuery(graphql`{
    allTemplatesDataJson {
      edges {
        node {
          alt
          image {
            childImageSharp {
              gatsbyImageData(
                quality: 100,
                outputPixelDensities: 2,
                placeholder: NONE,
                backgroundColor: "#27304D"
                pngOptions: {quality: 100},
                width: 235,
                height: 230
              )
            }
          }
        }
      }
    }
  }`)

  let templateData = query.allTemplatesDataJson.edges

  return (
    <div className='homepage-ts-wrapper'>
      <div className='homepage-ts-wrapper__templates'>
        <div className='homepage-ts-wrapper__templates__frame'>
          <div className='homepage-ts-wrapper__templates__frame__design'>
            <div className='homepage-ts-wrapper__templates__frame__design__header'>
                <h2>
                  Design a booking website that matches your brand
                </h2>
              <div className='homepage-ts-wrapper__templates__frame__design__header__subtitle'>
                Trafft comes with dark and light mode and eight base themes that you can further fine-tune and customize to make the look & feel of the booking process completely unique.</div>
            </div>
            <div className='homepage-ts-wrapper__templates__frame__design__images'>
              {templateData.map((item, index) => (
                <GatsbyImage key={index} image={item.node.image.childImageSharp.gatsbyImageData} alt={item.node.alt}/>
              ))}
            </div>
          </div>
        </div>
        <ButtonLink
          href={getRedirectionLink()}
          onClick={pushToDataLayer}
          label="Get started for free"
          target="_blank"
          extraClass='primary'
        />
      </div>
    </div>
  )
}

export default TemplateSection

